import Vue from 'vue'
import Clipboard from './clipboard'
import LoadCover from './LoadCover'

export default {
  install(Vue, options) {
    Vue.directive('clipboard', Clipboard)
    Vue.directive('loadcover', LoadCover)
  },
}
